import { Store, Module, ActionContext } from 'vuex'
import Ajax from '../../lib/ajax'
import ListModule from './list-module'
import ListState from './list-state'
import appconst from './../../lib/appconst';
import PageResult from '@/store/entities/page-result';
import ViewPreOrderShortedSku from '../entities/report-preorder/view-preorder-shorted-sku'
interface ViewPreOrderShortedSkuState extends ListState<ViewPreOrderShortedSku> {
   
}
class ViewPreOrderShortedSkuModule extends ListModule<ViewPreOrderShortedSkuState, any, ViewPreOrderShortedSku>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ViewPreOrderShortedSku>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<ViewPreOrderShortedSkuState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/ViewPreOrderShortQty/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<ViewPreOrderShortedSku>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getAllPreOrderShortedSkuBySoRequestCodes(context: ActionContext<ViewPreOrderShortedSkuState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/ViewPreOrderShortQty/GetAllPreOrderShortedSkuBySoRequestCodes', { params: payload.data });
            context.state.loading = false;
            return result ;
        },
        async exportAllShortedSkuToExcel(context:ActionContext<ViewPreOrderShortedSkuState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/ExportAllPreOrderShortQty?keyWord=`+payload.data.keyWord+`&warehouseCode=`+payload.data.warehouseCode, "_blank");    
        },
        async exportAllPreOrderSaleOrderShortedSkuToExcel(context:ActionContext<ViewPreOrderShortedSkuState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/ExportAllPreOrderSaleOrderShortedSku?productId=`+payload.data.productId+`&warehouseCode=`+payload.data.warehouseCode, "_blank");    
        },
        async exportAllPreOrderShortQtyBySoRequestCodeToExcel(context:ActionContext<ViewPreOrderShortedSkuState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/ExportAllPreOrderShortQtyBySoRequestCode?keyWord=`+payload.data.keyWord+`&warehouseCode=`+payload.data.warehouseCode, "_blank");    
        },
        async exportAllPreOrderSaleOrderShortedSkuBySoRequestCodeToExcel(context:ActionContext<ViewPreOrderShortedSkuState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/ExportAllPreOrderSaleOrderShortedSkuBySoRequestCode?productId=`+payload.data.productId+`&keyWord=`+payload.data.keyWord+`&warehouseCode=`+payload.data.warehouseCode, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: ViewPreOrderShortedSkuState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ViewPreOrderShortedSkuState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}
const viewPreOrderShortedSkuModule = new ViewPreOrderShortedSkuModule();
export default viewPreOrderShortedSkuModule;